import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { PortalTarget } from 'portal-vue';

import { ReceiptItem } from '../../types/types';

import { BTicketAdditionalInfo, BTicket } from 'ui-shared-components'

interface ReceiptBookingOrderProps {
  isParkingProduct: boolean;
  item: ReceiptItem;
  orderReference: string;
  subItems: ReceiptItem[];
  modifications: {
    displayCancellationPolicy?: boolean;
    hideAccessSection?: boolean;
    hideLocationInfo?: boolean;
    hideDirections?: boolean;
    showPaymentForPrint?: boolean;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'receipt-booking-order',
  props: {
    isParkingProduct: { type: Boolean, default: false },
    item: null,
    orderReference: { default: '' },
    subItems: { default: () => [] },
    modifications: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { isParkingProduct: boolean, item: ReceiptItem, orderReference: string, subItems: ReceiptItem[], modifications: {
    displayCancellationPolicy?: boolean;
    hideAccessSection?: boolean;
    hideLocationInfo?: boolean;
    hideDirections?: boolean;
    showPaymentForPrint?: boolean;
  } };



const isPrivateTerminal = computed(() => {
  return (
    props.item.inventory_item?.product_option?.code === 'lounge_private'
  );
});

const cancellationPolicies = computed(() => {
  if (props.item.cancellation_protection) {
    return props.item.cancellation_protection.cancellation_policies;
  }
  return props.item.inventory_option.cancellation_policies;
});


return { __sfc: true,props, isPrivateTerminal, cancellationPolicies, PortalTarget, BTicketAdditionalInfo, BTicket }
}

})